module.exports = __webpack_public_path__ + "img/root10.2ae078e7.png";